<template lang="pug">
filter-detail-container(
  :title="title"
  @back="back"
  @save="save"
)
  template(v-slot:body)
    .pa-6
      yc-text-field.mt-4(label="IC or passport number here without -" v-model="nameExact")
      .ma-2.text-xs.primary400--text Example: 880812035347
</template>

<script>
import FilterDetailContainer from './FilterDetailContainer.vue'

export default {
  props: ['type', 'filter'],
  components: { FilterDetailContainer },
  data: () => ({
    nameAll: '',
    nameExact: '',
    nameNone: ''
  }),
  computed: {
    title() {
      return `Filter ${this.$options.filters.capitalize(this.type)}`
    }
  },
  created() {
    this.nameAll = this.filter.all || ''
    this.nameExact = this.filter.exact || ''
    this.nameNone = this.filter.none || ''
  },
  methods: {
    save() {
      const filter = {
        all: this.nameAll,
        exact: this.nameExact,
        none: this.nameNone
      }
      this.$emit('update:filter', filter)
      this.back()
    },
    back() {
      this.$emit('onBack')
    }
  }
}
</script>